<template>
	<div class="rubber-type-switch">
		<select
			class="rubber-type-switch__select"
			@change="handleUserChangeRubberType"
		>
			<option
				v-for="rubberType in rubberTypes"
				:key="rubberType"
				:selected="rubberType === activeRubberType"
			>
				{{ rubberType }}
			</option>
		</select>
	</div>
</template>


<style lang="scss">
.rubber-type-switch {
	$blue: #0093C9;

	display: flex;
	place-content: center;
	place-items: center;
	text-align: center;
	margin-bottom: 36px;

	.choices {
		border: 3px solid $blue;
		border-radius: 100px;
		background-color: transparent;

		&__inner {
			background-color: transparent;
			width: auto;
			border: none !important;
		}

		&__list {
			&--single {
				font-weight: bolder;
				font-size: 18px;
				color: $blue;
				padding-right: 32px;
			}

			&--dropdown {
				max-width: calc( 100vw - 20px );
				width: 200px;
				text-align: left;
			}
		}
	}
}

</style>


<script setup>
const props = defineProps({
	activeRubberType: {
		type: String,
		required: true,
	},
	rubberTypes: {
		type: Array,
		required: true,
	},
})


const emit = defineEmits(
	[
		'rubber-type:change',
	],
)


/**
 * Handle user selecting different rubber type
 *
 * @param {CustomEvent|Event} e
 * @return {void}
 */
const handleUserChangeRubberType = e => {
	const { value } = e.target

	if ( value === props.activeRubberType ) {
		return
	}

	emit( 'rubber-type:change', value )
}

</script>
